module.exports = __webpack_public_path__ + "static/media/facebook-icon.1cd9b0e4.png";